// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-root {\n  width: 100%;\n  height: calc(100vh - 60px);\n  overflow-y: scroll;\n  padding-bottom: 100px;\n}", "",{"version":3,"sources":["webpack://src/components/Page/style.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;AACF","sourcesContent":[".page-root {\n  width: 100%;\n  height: calc(100vh - 60px);\n  overflow-y: scroll;\n  padding-bottom: 100px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
